import React, { forwardRef } from 'react';
import * as S from './Styles';

type MediaItem = {
  type: 'image' | 'video';
  url: string;
  thumbUrl?: string;
};

interface ThumbnailListProps {
  mediaItems: MediaItem[];
  onThumbnailClick: (index: number) => void;
  activeIndex: number;
  videoThumbnail: string;
  mediaItemsLength: number;
  siteId?: string;
}

const ThumbnailList = forwardRef<HTMLDivElement, ThumbnailListProps>(
  ({ mediaItems, onThumbnailClick, activeIndex, videoThumbnail, mediaItemsLength, siteId }, ref) => {
    function processMediaItems(
      mediaItems: MediaItem[]
    ): (MediaItem & { originalIndex: number; displayIndex: number })[] {
      let displayIndex = 0;
      return mediaItems.map((item, index) => ({
        ...item,
        originalIndex: index,
        displayIndex: displayIndex++
      }));
    }

    const isFmicAssetsImage = (url: string): boolean => {
      return url.includes('www.fmicassets.com');
    };

    const getResizedThumbnailUrl = (url: string): string => {
      return isFmicAssetsImage(url) ? url : `${url}?width=100`;
    };

    const itemList = processMediaItems(mediaItems);

    return (
      <S.ThumbnailList ref={ref} mediaItemsLength={mediaItemsLength}>
        {itemList.map((item, index) => {
          const isActive = item.displayIndex === activeIndex;

          switch (item.type) {
            case 'image':
              return (
                <S.ImageThumbnailContainer
                  siteId={siteId}
                  tabIndex={0}
                  key={item.url}
                  className={isActive ? 'activeStyle' : ''}
                  onClick={() => onThumbnailClick(item.displayIndex)}
                  onKeyDown={(e: { key: string }) => e.key === 'Enter' && onThumbnailClick(item.displayIndex)}
                >
                  <S.ThumbnailImage
                    src={getResizedThumbnailUrl(item.thumbUrl || item.url)}
                    alt={`Product Thumbnail ${index + 1} of ${mediaItems.length}`}
                  />
                </S.ImageThumbnailContainer>
              );

            case 'video':
              return (
                <S.VideoThumbnailContainer
                  siteId={siteId}
                  tabIndex={0}
                  key={item.url}
                  className={isActive ? 'activeStyle' : ''}
                  onClick={() => onThumbnailClick(item.displayIndex)}
                  onKeyDown={(e: { key: string }) => e.key === 'Enter' && onThumbnailClick(item.displayIndex)}
                >
                  <S.VideoThumbnail
                    siteId={siteId}
                    src={getResizedThumbnailUrl(videoThumbnail)}
                    alt="Product Video Thumbnail"
                  />
                  <S.PlayIcon
                    loading="lazy"
                    src="https://www.fmicassets.com/sites/fender.com/themes/img/play-button.svg"
                  />
                </S.VideoThumbnailContainer>
              );
            default:
              return null;
          }
        })}
      </S.ThumbnailList>
    );
  }
);

export default ThumbnailList;
